export default "__VITE_ASSET__CuiZly4s__"